import { Box } from '@mui/material'
import React from 'react'
import { Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'

const BackEndDetail = () => {
    return (
        <>
            {/* Career Detail Banner */}
            <section className='about-page'>
                <div className='about-bg'>
                    <div className='c-detail-shap-1 con-shap-c'>
                        <img src="../assets/images/whi-5.svg" alt="" />
                    </div>
                    <div className='about-shap-3'>
                        <img src="../assets/images/about-shap-1.png" alt="" />
                    </div>
                    <div className='about-shap-4'>
                        <img src="../assets/images/about-shap-2.png" alt="" />
                    </div>
                    <div className='about-shap-5 con-shap-c'>
                        <img src="../assets/images/about-shap-3.svg" alt="" />
                    </div>
                    <div className='career-shap-22'>
                        <img src="../assets/images/whi-3.svg" alt="" />
                    </div>
                    <Container>
                        <Row className='align-items-center'>
                            <div className='col-lg-5 d-lg-block d-none position-relative' data-aos="fade-right" data-aos-duration="2000">
                                <div className='career-img text-center'>
                                    <img src="../assets/images/back-banner.png" alt="" />
                                </div>
                                <div className='career-shap-1'>
                                    <img src="../assets/images/white-arr.svg" alt="" />
                                </div>
                            </div>
                            <div className='col-xl-6 col-lg-5 padding-0' data-aos="fade-left" data-aos-duration="2000">
                                <div className='tech-content'>
                                    <h2>Back End Developer</h2>
                                    <p>At IMUII, our Back End Developers are the backbone of digital innovation. In this role, you'll build scalable, secure, and high-performance server-side applications that power seamless user experiences. From managing databases to creating robust APIs, your work ensures our platforms run smoothly and efficiently behind the scenes. You’ll collaborate with front-end teams, contribute to architecture decisions, and solve complex problems using modern frameworks and cloud technologies. If you're passionate about clean code and strong logic, this is where your skills will thrive. </p>
                                    <div className='interest-btn'>
                                        <Link to='/career-form'>
                                            <button className='job-btn'>I’m Interested</button>
                                        </Link>
                                        <Link to='/career-form'>
                                            <button className='friend-btn'>Refer A Friend</button>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </Row>
                    </Container>
                </div>
            </section>
    
            {/* Information Section */}
            <section className='information-section'>
                <Container>
                    <Row>
                        <div className="col-md-6 mb-30" data-aos="fade-up-right" data-aos-duration="2000">
                            <div className="information-card">
                                <h3>Job Information</h3>
                                <Row>
                                    <div className="col-lg-6 col-md-12 col-sm-6 information-margin">
                                        <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '10px'
                                        }}>
                                            <div className='information-icon'>
                                                <img src="../assets/images/c-detail-1.svg" alt="" />
                                            </div>
                                            <div className='information-text'>
                                                <p>Region</p>
                                                <h5>Tamil Nadu</h5>
                                            </div>
                                        </Box>
                                    </div>
                                    <div className="col-lg-6 col-md-12 col-sm-6 information-margin">
                                       <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '10px'
                                        }}>
                                            <div className='information-icon'>
                                                <img src="../assets/images/c-detail-2.svg" alt="" />
                                            </div>
                                            <div className='information-text'>
                                                <p>Industry</p>
                                                <h5>Technology</h5>
                                            </div>
                                        </Box>
                                    </div>
                                    <div className="col-lg-12 col-md-12 col-sm-12 information-margin">
                                         <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '10px'
                                        }}>
                                            <div className='information-icon'>
                                                <img src="../assets/images/back-career.svg" alt="" />
                                            </div>
                                            <div className='information-text'>
                                                <p>Role</p>
                                                <h5>Back End Developer</h5>
                                            </div>
                                        </Box>
                                        
                                    </div>
                                </Row>
                            </div>
                        </div>
                        <div className="col-md-6 mb-30" data-aos="fade-up-left" data-aos-duration="2000">
                            <div className="information-card">
                                <h3>Other Information</h3>
                                <Row>
                                    <div className="col-lg-6 col-md-12 col-sm-6 information-margin">
                                        <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '10px'
                                        }}>
                                            <div className='information-icon'>
                                                <img src="../assets/images/c-detail-4.svg" alt="" />
                                            </div>
                                            <div className='information-text'>
                                                <p>Education</p>
                                                <h5>UG / PG</h5>
                                            </div>
                                        </Box>
                                    </div>
                                    <div className="col-lg-6 col-md-12 col-sm-6 information-margin">
                                       <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '10px'
                                        }}>
                                            <div className='information-icon'>
                                                <img src="../assets/images/c-detail-5.svg" alt="" />
                                            </div>
                                            <div className='information-text'>
                                                <p>Passed Out</p>
                                                <h5>2019</h5>
                                            </div>
                                        </Box>
                                    </div>
                                    <div className="col-lg-12 col-md-12 col-sm-12 information-margin">
                                        <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '10px'
                                        }}>
                                            <div className='information-icon'>
                                                <img src="../assets/images/c-detail-6.svg" alt="" />
                                            </div>
                                            <div className='information-text'>
                                                <p>Salary Range</p>
                                                <h5>₹ 3 to 7 LPA</h5>
                                            </div>
                                        </Box>
                                    </div>
                                </Row>
                            </div>
                        </div>
                    </Row>
                </Container>
            </section>
    
            {/* Job Description Section */}
            <section className='job-description-section'>
                <Container>
                    <div className='job-description' data-aos="fade-right" data-aos-duration="2000">
                        <h3>Job Description</h3>
                        <p> As a Back End Developer at IMUII, you'll be responsible for building and maintaining the core logic, databases, and APIs that power our web and mobile applications. You'll collaborate closely with front-end developers, DevOps, and project managers to ensure smooth and secure data flow. The role involves working with cloud services, writing scalable code, optimizing performance, and maintaining security best practices.</p>
                        <p> A deep understanding of backend frameworks, RESTful APIs, and database architecture is essential. You will also contribute to code reviews and system design discussions to help shape technical direction and product strategy. We value individuals who can work independently, write clean and testable code, and stay updated with emerging technologies. Whether it's implementing complex algorithms or debugging intricate server-side issues, your work will directly impact how users experience our products. </p>
                        <p>You'll thrive if you're comfortable juggling multiple priorities, delivering under tight deadlines, and maintaining high standards in backend architecture. We're looking for someone passionate about backend innovation and committed to continuously improving systems. If you enjoy solving complex backend challenges and building resilient infrastructure, IMUII is the place for you. </p>
                    </div>
                </Container>
            </section>
    
            {/* Key Responsibility Section */}
            <section className='key-responsibility-section'>
                <Container>
                    <div className='key-responsibility' data-aos="fade-left" data-aos-duration="2000">
                        <h3>Key Responsibility</h3>
                        <ul>
                            <li>
                                <p>Develop and maintain backend logic, services, and RESTful APIs supporting web and mobile applications. </p>
                            </li>
                            <li>
                                <p>Design and optimize databases, ensuring data integrity, speed, and security. </p>
                            </li>
                            <li>
                                <p>Collaborate with front-end and DevOps teams to integrate server-side logic with UI layers. </p>
                            </li>
                            <li>
                                <p>Ensure application performance and scalability through efficient backend architecture. </p>
                            </li>
                            <li>
                                <p>Implement authentication, authorization, and role-based access controls. </p>
                            </li>
                            <li>
                                <p>Maintain code quality through testing, documentation, and regular code reviews. </p>
                            </li>
                            <li>
                                <p>Monitor server health, log activities, and respond to production incidents swiftly. </p>
                            </li>
                            <li>
                                <p>Stay current with backend trends and technologies, suggesting innovations as needed. </p>
                            </li>
                            <li>
                                <p>Participate in system architecture discussions and long-term technical planning </p>
                            </li>
                        </ul>
                    </div>
    
                    <div className='btn-margin' data-aos="zoom-in" data-aos-duration="2000">
                        <Link to='/career-form'>
                            <button className='interested-btn'>I’m Interested</button>
                        </Link>
                    </div>
                </Container>
            </section>
            
        </>
    )
}

export default BackEndDetail
